<div class="component-container lg:px-[5rem] md:px-[2.8rem] xs:px-[1rem]">
  <div
    *ngIf="loading; else loadedData"
    class="loading-section flex justify-center items-center"
  >
    <mat-progress-spinner
      class="loader"
      mode="indeterminate"
      strokeWidth="10"
    ></mat-progress-spinner>
  </div>
  <ng-template #loadedData>
    <div
      class="action-section flex flex-row w-full justify-end items-center pb-0 sm:pb-[1.6rem]"
    >
      <app-primary-button
        (handleClick)="save()"
        [isLoading]="markAttendanceLoading"
        class="btn w-[15rem]"
        type="small"
      >
        Save
      </app-primary-button>
    </div>
      <div
        *ngFor="let user of userList, let i = index"
        class="user-block"
      >
        <mat-expansion-panel>
          <mat-expansion-panel-header class="!pl-6 !pr-0 sm:!pr-6">
            <mat-panel-title>
              {{ user?.name }}<div class="block sm:hidden"><span *ngIf="user?.isLar">(LAR)</span></div><div class="hidden sm:block"> - {{ user?.type }}<span *ngIf="user?.isLar">(LAR)</span><span *ngIf="user.role === roles.adult && user?.relationWithParticipant" [class.relation-other]="user?.isOtherRelation" [title]="user?.isOtherRelation ? user?.relationWithParticipant : ''">,&nbsp;{{ user?.relationWithParticipant }}</span>&nbsp;- Age {{ user?.age }}</div>
            </mat-panel-title>
            <mat-panel-description class="!mr-0">
              <app-user-attendance
                [form]="this.form?.controls?.['userList']?.controls[i]"
                [user]="user"
                [disabled]="sessionCompleted || groupStatus !== 2 || sessionDetails?.participantStatus?.key === 4 || sessionDetails?.participantGroupStatus === 4"
              ></app-user-attendance>
            </mat-panel-description>
          </mat-expansion-panel-header>
            <app-user
              [form]="this.form?.controls?.['userList']?.controls[i]"
              (downloadVisitNoteClicked)="downloadVisitNotes($event)"
              [groupStatus]="groupStatus"
              [sessionCompleted]="sessionCompleted"
              [sessionDetails]="sessionDetails"
              [user]="user"
              [groupId]="groupId"
            ></app-user>
        </mat-expansion-panel>
      </div>
    <div class="other-section flex flex-row xs:flex-col gap-[20px] xs:gap-0">
      <div class="sub-heading">
        Others attending
      </div>
      <div
        class="row flex flex-col justify-start items-end gap-0">
        <app-number-input
          #otherChildrenInput
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['otherChildren']"
          [parentFormGroup]="form"
          class="input w-[200px]"
          controlName="otherChildren"
          label="Children"
          placeholder="00"
          type="small"
        ></app-number-input>
        <app-number-input
          #otherAdultsInput
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['otherAdults']"
          [parentFormGroup]="form"
          class="input w-[200px]"
          controlName="otherAdults"
          label="Adults"
          placeholder="00"
          type="small"
        ></app-number-input>
        
      </div>
    </div>
  </ng-template>
</div>

